module.exports = __webpack_public_path__ + "static/img/bg_error.de4e5c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_error.jpg
// module id = 737
// module chunks = 2